import React from "react";
import WhiteButton from "../../../../Components/WhiteButton";
import { Link } from "react-scroll";

const CareersInitialSection = () => {
  const careerList = [
    { title: "20+", description: "Data & AI Experts" },
    { title: "100+", description: "Years Data Science Experience" },
  ];

  return (
    <section className="relative mb-12">
      <div className="flex flex-col p-1 md:p-4 min-h-screen">
        <div className="text-white flex-1 flex flex-col">
          <main className="flex-1 flex flex-col items-center pt-[16%] md:pt-[6%] mx-[6%] md:mx-[32%] z-10 pb-[4%]">
            <h1 className="text-4xl md:text-7xl font-extrabold text-center text-white leading-[140%] tracking-[0] mb-6">
              Build With Us, Grow With Us
            </h1>

            <p className="text-center text-lg md:text-xl font-medium leading-[140%] tracking-[0] md:mx-[5%] text-white md:px-[12%]">
              Join us in shaping the future of AI with purpose and innovation.
            </p>

            <Link to="see-open-roles" smooth="true" duration={100}>
              <WhiteButton
                text="See Open Roles"
                className="mt-8 md:mt-10"
                onClick={() => {}}
              />
            </Link>
          </main>
          <div className="md:px-[8%]">
            <div
              className={`relative overflow-hidden text-white h-[443px] md:h-auto md:aspect-[4/2] min-w-full flex flex-row`}
            >
              <img
                src="/images/careers-page/careers-image-1.jpeg"
                alt="AI Strategy"
                className="w-full h-full object-cover absolute object-center grayscale"
              />
              {/* Top Shadow */}
              <div className="absolute top-0 left-0 w-full h-32 bg-gradient-to-b from-app-background to-transparent z-10" />

              {/* Bottom Shadow */}
              <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-app-background to-transparent z-10" />

              {/* Left Shadow */}
              <div className="absolute top-0 left-0 h-full w-32 bg-gradient-to-r from-app-background to-transparent z-10" />

              {/* Right Shadow */}
              <div className="absolute top-0 right-0 h-full w-32 bg-gradient-to-l from-app-background to-transparent z-10" />
            </div>
          </div>
          <div className="py-[6%] px-8 md:px-0 flex flex-col md:flex-row items-center justify-center space-y-20 md:space-y-0 md:space-x-40">
            {careerList.map((career) => (
              <div
                key={career.title}
                className="flex flex-col items-center justify-center text-center"
              >
                <h1 className="font-medium text-[100px] md:text-[160px] leading-[140%] tracking-[0%] text-center">
                  {career.title}
                </h1>
                <p className="font-medium text-[24px] md:text-[32px] leading-[140%] tracking-[0%] text-center">
                  {career.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CareersInitialSection;
